import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export type CookieConsentStatus = 'accepted' | 'declined' | null;
const COOKIE_KEY = 'cookie_consent';
const COOKIE_EXP_DAYS = 365;
const readCookie = (): CookieConsentStatus => {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie.split(';').map(c => c.trim());
  for (const cookie of cookies) if (cookie.startsWith(`${COOKIE_KEY}=`)) {
    const value = cookie.split('=')[1];
    if (value === 'accepted' || value === 'declined') return value;
  }
  return null;
};
const writeCookie = (status: 'accepted' | 'declined') => {
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_EXP_DAYS);
  document.cookie = `${COOKIE_KEY}=${status}; path=/; max-age=${60 * 60 * 24 * COOKIE_EXP_DAYS}; SameSite=Lax`;
};
export const useCookieConsent = () => {
  const $ = _c(8);
  const [status, setStatus] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const stored = localStorage.getItem(COOKIE_KEY) as CookieConsentStatus | null;
      const cookie = readCookie();
      if (stored) {
        setStatus(stored);
      } else {
        if (cookie) {
          setStatus(cookie);
          localStorage.setItem(COOKIE_KEY, cookie);
        }
      }
      setIsLoaded(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      localStorage.setItem(COOKIE_KEY, "accepted");
      writeCookie("accepted");
      setStatus("accepted");
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const accept = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      localStorage.setItem(COOKIE_KEY, "declined");
      writeCookie("declined");
      setStatus("declined");
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const decline = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      localStorage.removeItem(COOKIE_KEY);
      document.cookie = `${COOKIE_KEY}=; path=/; max-age=0`;
      setStatus(null);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const reset = t4;
  let t5;
  if ($[5] !== isLoaded || $[6] !== status) {
    t5 = {
      accept,
      decline,
      reset,
      status,
      isLoaded
    };
    $[5] = isLoaded;
    $[6] = status;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};